import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { readStoredJson } from '../lib/storage';
import { API_URL } from '../lib/api';

export const translations = {
  en: {
    app_name: 'Monster Huddle',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    logout: 'Logout',
    settings: 'Settings',

    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    confirm_password: 'Confirm Password',
    login_title: 'Welcome Back!',
    login_subtitle: 'Sign in to continue your learning journey',
    register_title: 'Join Monster Huddle',
    register_subtitle: 'Start your learning adventure today',
    no_account: "Don't have an account?",
    have_account: 'Already have an account?',

    dashboard: 'Dashboard',
    welcome_back: 'Welcome back',
    choose_subject: 'Choose a Subject',
    your_progress: 'Your Progress',
    total_points: 'Total Points',
    current_level: 'Current Level',
    time_spent: 'Time Spent',
    quizzes_done: 'Quizzes Done',
    continue_learning: 'Continue Learning',

    subjects: 'Subjects',
    bm: 'Bahasa Malaysia',
    history: 'History',
    science: 'Science',

    levels: 'Levels',
    level: 'Level',
    determination: 'Determination',
    discipline: 'Discipline',
    perseverance: 'Perseverance',
    hardworking: 'Hard-working',
    breakthrough: 'Breakthrough',
    locked: 'Locked',
    unlocked: 'Unlocked',
    unlock_at: 'Unlock at',
    points: 'points',

    stages: 'Stages',
    stage: 'Stage',
    completed: 'Completed',
    start_stage: 'Start',

    quiz: 'Quiz',
    question: 'Question',
    time_remaining: 'Time Remaining',
    submit_answers: 'Submit Answers',

    results: 'Results',
    congratulations: 'Congratulations!',
    your_score: 'Your Score',
    points_earned: 'Points Earned',
    time_taken: 'Time Taken',
    correct_answers: 'Correct Answers',
    try_again: 'Try Again',
    next_stage: 'Next Stage',
    back_to_levels: 'Back to Levels',
    level_up: 'Level Up!',

    leaderboard: 'Leaderboard',
    rank: 'Rank',
    player: 'Player',
    global_ranking: 'Global Ranking',

    history_title: 'Quiz History',
    no_history: 'No quiz history yet',
    date: 'Date',
    score: 'Score',

    notices: 'Notices',
    announcements: 'Announcements',
    no_notices: 'No announcements',

    admin_panel: 'Admin Panel',
    manage_questions: 'Manage Questions',
    manage_users: 'Manage Users',
    manage_notices: 'Manage Notices',
    reports: 'Reports',
    upload_questions: 'Upload Questions',
    add_question: 'Add Question',
    bulk_upload: 'Bulk Upload (CSV)',

    language: 'Language',
    change_password: 'Change Password',
    current_password: 'Current Password',
    new_password: 'New Password',

    minutes: 'minutes',
    seconds: 'seconds',
    of: 'of',
    hours: 'hours',

    live_competition: 'LIVE Competition',
    host_room: 'Host Room',
    join_by_code: 'Join by Code',
    quick_match: 'Quick Match',
    tournaments_label: 'Tournaments',
    room_code: 'Room Code',
    create_room: 'Create Room',
    start_game: 'Start Game'
  },
  zh: {
    app_name: 'Monster Huddle',
    loading: '\u52a0\u8f7d\u4e2d...',
    save: '\u4fdd\u5b58',
    cancel: '\u53d6\u6d88',
    delete: '\u5220\u9664',
    edit: '\u7f16\u8f91',
    back: '\u8fd4\u56de',
    next: '\u4e0b\u4e00\u6b65',
    submit: '\u63d0\u4ea4',
    logout: '\u9000\u51fa\u767b\u5f55',
    settings: '\u8bbe\u7f6e',

    login: '\u767b\u5f55',
    register: '\u6ce8\u518c',
    email: '\u7535\u5b50\u90ae\u4ef6',
    password: '\u5bc6\u7801',
    name: '\u59d3\u540d',
    confirm_password: '\u786e\u8ba4\u5bc6\u7801',
    login_title: '\u6b22\u8fce\u56de\u6765!',
    login_subtitle: '\u767b\u5f55\u4ee5\u7ee7\u7eed\u60a8\u7684\u5b66\u4e60\u4e4b\u65c5',
    register_title: '\u52a0\u5165 Monster Huddle',
    register_subtitle: '\u4eca\u5929\u5f00\u59cb\u60a8\u7684\u5b66\u4e60\u5192\u9669',
    no_account: '\u8fd8\u6ca1\u6709\u8d26\u6237?',
    have_account: '\u5df2\u6709\u8d26\u6237?',

    dashboard: '\u4eea\u8868\u677f',
    welcome_back: '\u6b22\u8fce\u56de\u6765',
    choose_subject: '\u9009\u62e9\u79d1\u76ee',
    your_progress: '\u60a8\u7684\u8fdb\u5ea6',
    total_points: '\u603b\u79ef\u5206',
    current_level: '\u5f53\u524d\u5173\u5361',
    time_spent: '\u82b1\u8d39\u65f6\u95f4',
    quizzes_done: '\u5b8c\u6210\u6d4b\u9a8c',
    continue_learning: '\u7ee7\u7eed\u5b66\u4e60',

    subjects: '\u79d1\u76ee',
    bm: '\u9a6c\u6765\u8bed',
    history: '\u5386\u53f2',
    science: '\u79d1\u5b66',

    levels: '\u5173\u5361',
    level: '\u5173\u5361',
    determination: '\u51b3\u5fc3',
    discipline: '\u81ea\u5f8b',
    perseverance: '\u6bc5\u529b',
    hardworking: '\u52e4\u52b3',
    breakthrough: '\u7a81\u7834',
    locked: '\u5df2\u9501\u5b9a',
    unlocked: '\u5df2\u89e3\u9501',
    unlock_at: '\u89e3\u9501\u9700\u8981',
    points: '\u79ef\u5206',

    stages: '\u9636\u6bb5',
    stage: '\u9636\u6bb5',
    completed: '\u5df2\u5b8c\u6210',
    start_stage: '\u5f00\u59cb',

    quiz: '\u6d4b\u9a8c',
    question: '\u95ee\u9898',
    time_remaining: '\u5269\u4f59\u65f6\u95f4',
    submit_answers: '\u63d0\u4ea4\u7b54\u6848',

    results: '\u7ed3\u679c',
    congratulations: '\u606d\u559c!',
    your_score: '\u60a8\u7684\u5206\u6570',
    points_earned: '\u83b7\u5f97\u79ef\u5206',
    time_taken: '\u7528\u65f6',
    correct_answers: '\u6b63\u786e\u7b54\u6848',
    try_again: '\u518d\u8bd5\u4e00\u6b21',
    next_stage: '\u4e0b\u4e00\u9636\u6bb5',
    back_to_levels: '\u8fd4\u56de\u5173\u5361',
    level_up: '\u5347\u7ea7\u4e86!',

    leaderboard: '\u6392\u884c\u699c',
    rank: '\u6392\u540d',
    player: '\u73a9\u5bb6',
    global_ranking: '\u5168\u7403\u6392\u540d',

    history_title: '\u6d4b\u9a8c\u5386\u53f2',
    no_history: '\u6682\u65e0\u6d4b\u9a8c\u5386\u53f2',
    date: '\u65e5\u671f',
    score: '\u5206\u6570',

    notices: '\u901a\u77e5',
    announcements: '\u516c\u544a',
    no_notices: '\u6682\u65e0\u516c\u544a',

    admin_panel: '\u7ba1\u7406\u9762\u677f',
    manage_questions: '\u7ba1\u7406\u95ee\u9898',
    manage_users: '\u7ba1\u7406\u7528\u6237',
    manage_notices: '\u7ba1\u7406\u901a\u77e5',
    reports: '\u62a5\u544a',
    upload_questions: '\u4e0a\u4f20\u95ee\u9898',
    add_question: '\u6dfb\u52a0\u95ee\u9898',
    bulk_upload: '\u6279\u91cf\u4e0a\u4f20 (CSV)',

    language: '\u8bed\u8a00',
    change_password: '\u4fee\u6539\u5bc6\u7801',
    current_password: '\u5f53\u524d\u5bc6\u7801',
    new_password: '\u65b0\u5bc6\u7801',

    minutes: '\u5206\u949f',
    seconds: '\u79d2',
    of: '/',
    hours: '\u5c0f\u65f6',

    live_competition: '\u5b9e\u65f6\u7ade\u8d5b',
    host_room: '\u521b\u5efa\u623f\u95f4',
    join_by_code: '\u8f93\u5165\u4ee3\u7801',
    quick_match: '\u5feb\u901f\u5339\u914d',
    tournaments_label: '\u9526\u6807\u8d5b',
    room_code: '\u623f\u95f4\u4ee3\u7801',
    create_room: '\u521b\u5efa\u623f\u95f4',
    start_game: '\u5f00\u59cb\u6e38\u620f'
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const u = readStoredJson('user');
    if (['en', 'zh'].includes(u?.language)) return u.language;
    const saved = localStorage.getItem('language');
    return ['en', 'zh'].includes(saved) ? saved : 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => translations[language]?.[key] || translations.en[key] || key;

  const setLanguage = (lang) => {
    if (!['en', 'zh'].includes(lang)) return;
    setLanguageState(lang);
    localStorage.setItem('language', lang);
    const u = readStoredJson('user');
    if (u) {
      u.language = lang;
      localStorage.setItem('user', JSON.stringify(u));
    }
  };

  const persistLanguage = async (lang) => {
    if (!['en', 'zh'].includes(lang)) return;
    setLanguage(lang);
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      await axios.put(
        `${API_URL}/api/user/language`,
        { language: lang },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (e) {
      // Non-fatal: the UI language still updates locally.
    }
  };

  const toggleLanguage = () => {
    persistLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, persistLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
